import 'core-js/stable';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js'
import axios from 'axios';
import store from './store';
import helper from './helper';
import HighchartsVue from 'highcharts-vue';


Vue.config.productionTip = false;
// axios.defaults.baseURL = 'http://localhost:8888/';
axios.defaults.baseURL = 'https://user.ai.inergi.id/';
// axios.defaults.baseURL = process.env.VUE_APP_URL;

//axios.defaults.headers.post['Content-Type'] = 'application/json';
//axios.defaults.headers.post['Accept'] = 'application/json';

router.beforeEach((to, from, next) => {
  var token = sessionStorage.getItem("token"); //Don't use global token above;
  axios.defaults.headers.common['Authorization'] = token;
  if (to.name !== 'Login'){// jika user menuju router page selain halaman login
    if (token){ // jika sudah autorisasi dengan login sehingga mendapat token dari B.E dan disimpan di sessionStorage
      next(); // maka di izinkan untuk next ke halaman yang di inginkan
    } else { // jika belum autorisasi (tidak memiliki token)
      next({name: 'Login'}); // maka akan di lempar ke halaman login
    }
  } else { // jika menuju halaman login, tanpa perlu checking token lagi, langsung di izinkan
    next();
  }
})
let errorLabel = {
  generic: 'Error!',
  emptyField: '-'
};

Vue.use(CoreuiVue);
Vue.use(HighchartsVue);
Vue.prototype.$axios = axios;
Vue.prototype.$helper = helper;
Vue.prototype.$errorLabel = errorLabel;
Vue.prototype.$appType = 'INERGI_LOG';
Vue.prototype.$realm = 'INERGI';

const rootApp = new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App></App>',
  components: {
    App,
  },
});

rootApp;
